export default "__VITE_ASSET__CAKPl$ib__"